var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      isolation: "isolate"
    },
    viewBox: "0 0 64 64",
    width: "64pt",
    height: "64pt",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clipPath_M9lrnCtregjpzNqgG7B9k7ezCy5Apsvq"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clipPath_M9lrnCtregjpzNqgG7B9k7ezCy5Apsvq)"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 26.26 10 C 32.023 10.002 37.311 13.193 40 18.29 C 44.444 15.693 50.039 16.158 53.992 19.455 C 57.945 22.751 59.409 28.171 57.653 33.009 C 55.897 37.848 51.297 41.067 46.15 41.06 L 26.26 41.11 C 17.669 41.11 10.705 34.146 10.705 25.555 C 10.705 16.964 17.669 10 26.26 10 Z ",
    fill: "rgb(255,255,255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: " M 38.38 55.79 C 32.614 55.792 27.32 52.6 24.63 47.5 C 20.186 50.097 14.591 49.632 10.638 46.335 C 6.685 43.039 5.221 37.619 6.977 32.781 C 8.733 27.942 13.333 24.723 18.48 24.73 L 38.37 24.68 C 46.961 24.68 53.925 31.644 53.925 40.235 C 53.925 48.826 46.961 55.79 38.37 55.79 L 38.38 55.79 Z ",
    fill: "rgb(255,255,255)"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "reBc4hYJvTiKzNZpoTWthy88gZzmKcDy",
    x: "-200%",
    y: "-200%",
    width: "400%",
    height: "400%",
    filterUnits: "objectBoundingBox",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    xmlns: "http://www.w3.org/2000/svg",
    stdDeviation: 0
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#reBc4hYJvTiKzNZpoTWthy88gZzmKcDy)"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 15.204 48.727 C 8.708 46.912 4.908 40.165 6.723 33.669 C 8.538 27.174 15.285 23.373 21.78 25.188 C 28.276 27.003 32.076 33.75 30.261 40.246 C 28.447 46.741 21.7 50.542 15.204 48.727 Z ",
    fill: "rgb(255,255,255)"
  })), /*#__PURE__*/React.createElement("path", {
    d: " M 42.867 40.609 C 36.371 38.794 32.571 32.047 34.386 25.552 C 36.201 19.056 42.948 15.256 49.443 17.071 C 55.939 18.886 59.739 25.633 57.924 32.128 C 56.109 38.624 49.362 42.424 42.867 40.609 Z ",
    fill: "rgb(255,255,255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: " M 27.88 38.15 C 26.966 38.504 25.989 38.667 25.01 38.63 C 21.15 38.63 19.16 36.23 19.16 33.05 C 19.16 29.24 21.88 27.12 25.25 27.12 C 26.192 27.088 27.13 27.258 28 27.62 L 27.49 29.62 C 26.818 29.343 26.097 29.203 25.37 29.21 C 24.384 29.146 23.421 29.519 22.735 30.23 C 22.049 30.941 21.711 31.917 21.81 32.9 C 21.715 33.881 22.059 34.853 22.75 35.556 C 23.441 36.258 24.408 36.619 25.39 36.54 C 26.105 36.54 26.816 36.419 27.49 36.18 L 27.88 38.15 Z ",
    fill: "rgb(0,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: " M 39.26 32.77 C 39.26 36.43 37.04 38.65 33.78 38.65 C 30.52 38.65 28.53 36.15 28.53 32.97 C 28.53 29.62 30.67 27.12 33.96 27.12 C 37.25 27.12 39.26 29.69 39.26 32.77 Z  M 31.2 32.92 C 31.2 35.11 32.2 36.65 33.92 36.65 C 35.64 36.65 36.6 35 36.6 32.85 C 36.6 30.85 35.6 29.12 33.9 29.12 C 32.2 29.12 31.2 30.75 31.2 32.92 Z ",
    fill: "rgb(0,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: " M 40.53 40.63 L 40.53 39.53 L 41.53 38.63 C 43.22 37.12 44.04 36.25 44.06 35.35 C 44.06 34.72 43.68 34.22 42.79 34.22 C 42.185 34.249 41.606 34.474 41.14 34.86 L 40.63 33.57 C 41.367 33.042 42.253 32.762 43.16 32.77 C 43.852 32.68 44.549 32.895 45.069 33.36 C 45.589 33.824 45.882 34.492 45.87 35.19 C 45.87 36.48 44.93 37.52 43.82 38.51 L 43.11 39.1 L 43.11 39.1 L 46 39.1 L 46 40.58 L 40.53 40.63 Z ",
    fill: "rgb(0,0,0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCo2);
export default __webpack_public_path__ + "static/media/Icon_co2.9591c54abed628ba68d52f1544f9f296.svg";
export { ForwardRef as ReactComponent };